import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Rex Wang 早年參與衛星導航核心、半導體設備、光碟機控制器等開發工作，曾經協助電信、金融與製造等類型產業客戶，在採購、電子商務、支付系統、智能電力系統等專案中擔任程式設計師、架構師等不同角色。`}</p>
    <p>{`Rex Wang 近年負責容器平台銷售工作，投入微服務相關架構設計工作，協助兩岸三地客戶進行應用改造；過程中接觸領域驅動設計等相關知識，體認到領域驅動設計的內涵相當廣泛，因此重新閱讀更多軟體工程相關典籍，強化領域驅動設計中重要的基礎知識，進而應用在實務工作之中。
Rex Wang 相信領域驅動設計不僅適用於微服務相關的設計與開發，也是軟體開發過程的開發指南，更是軟體工程相關知識的寶庫。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      